import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Form, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addCompetenciesScoreAction,
    updateCompetenciesScoreAction,
    deleteCompetenciesScoreAction
} from '../../../redux/actions/admin/adminAction';

export const CompetenciesScore = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'competencies_score': '', 'score': '' })
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'competencies_score': '', 'score': '' })
        setShow(false)
    };

    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateCompetenciesScore(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addCompetenciesScore(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteCompetenciesScore(id)
    }

    const [competenciesColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Competencies Score", field: 'competencies_score', filter: true, },
        { headerName: "Score", field: 'score', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])

    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={props.competenciesScore}
                defaultColDef={defaultColDef}
                columnDefs={competenciesColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>CompetenciesScores</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>

                    <Modal.Body>
                        <h3>CompetenciesScore</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="competencies_score"
                                name="competencies_score"
                                value={inputData.competencies_score}
                                onChange={handleChange}
                                placeholder="Competencies Score"
                                autoComplete="off"
                            />
                        </div>
                        <br></br>
                        <h3>Score</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="score"
                                name="score"
                                value={inputData.score}
                                onChange={handleChange}
                                placeholder="Score"
                                autoComplete="off"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const competenciesScore = state.admin.competenciesScore;
    return {
        competenciesScore: competenciesScore,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addCompetenciesScore: (data) => dispatch(addCompetenciesScoreAction(data)),
        updateCompetenciesScore: (id, data) => dispatch(updateCompetenciesScoreAction(id, data)),
        deleteCompetenciesScore: (id) => dispatch(deleteCompetenciesScoreAction(id)),
    };
};



export default connect(mapStateToProps, mapDispatchToProps)(CompetenciesScore)






